import React, { useEffect, useState } from "react";
import { RoomInfoManage } from "./RoomInfoManage";
import { RoomTypeManage } from "./RoomTypeManage";
import { DoorlockInfoManage } from "./DoorlockInfoManage";
import { QRTextManage } from "./QRTextManage";
import {
  roomAllByAccomSearchApi,
  roomTypeAllByAccomSearchApi,
} from "../api/api";

export const ManageMain = ({ currentMenuKey }) => {
  // 룸정보 (API 연결)
  const [roomAllList, setRoomAllList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await roomAllByAccomSearchApi();
        const resArray = Object.entries(res.rooms);
        const roomAllArray = resArray
          .map(([key, value, no]) => {
            return {
              key: key,
              value: value,
              no: value.display_name,
              roomTypeId: value.room_type_id,
              roomSaleId: value.room_sale_id,
              display_name : value.display_name,
              gid : value.gid,
              lid : value.lid,
              floor : value.floor,
              card_barcode : value.card_barcode,
              use_keyless : value.use_keyless,
            };
          })
          .sort((a, b) => a.no - b.no);
        setRoomAllList(roomAllArray);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  // 룸타입 정보 (API 연결)
  const [roomTypeAllList, setRoomTypeAllList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await roomTypeAllByAccomSearchApi();
        const resArray = Object.entries(res.room_types);
        const roomTypeAllArray = resArray.map(([key, value]) => {
          return {
            key: key,
            value: value,
          };
        });
        setRoomTypeAllList(roomTypeAllArray);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  
  return (
    <>
      {/* <h1>관리메뉴의 메인페이지 입니다.</h1> */}

      {currentMenuKey === "RoomInfoManage" ? (
        <RoomInfoManage roomTypeAllList={roomTypeAllList} />
      ) : currentMenuKey === "RoomTypeManage" ? (
        <RoomTypeManage roomTypeAllList={roomTypeAllList} />
      ) : currentMenuKey === "DoorlockInfoManage" ? (
        <DoorlockInfoManage roomAllList={roomAllList} />
      ) : currentMenuKey === "QRTextManage" ? (
        <QRTextManage />
      ) : (
        <RoomInfoManage
          roomAllList={roomAllList}
          setRoomAllList={setRoomAllList}
          roomTypeAllList={roomTypeAllList}
          setRoomTypeAllList={setRoomTypeAllList}
        />
      )}
    </>
  );
};
